import { render } from "./MySelectMFGSearchTerm.vue?vue&type=template&id=0135cd99"
import script from "./MySelectMFGSearchTerm.vue?vue&type=script&lang=js"
export * from "./MySelectMFGSearchTerm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__